import { Box, ButtonBase } from "@mui/material";
import NeoAvatar from "./NeoAvatar";

export default function ChatbotLauncher({ onClick, open, pending = false, label = "ให้Neo ช่วยไหมครับ?", right = { xs: 12, md: 20 }, bottom = { xs: 12, md: 20 } }) {
  return (
    <Box className="neo-pet" sx={{ position: "fixed", right, bottom, zIndex: 6, display: open ? "none" : "flex", alignItems: "center", gap: 1 }}>
      <Box className="neo-pet-greeting" aria-hidden="true" sx={{ display: { xs: "none", md: "block" }, px: 1.5, py: 1, maxWidth: 220, borderRadius: "14px 14px 4px 14px", background: "#152b3d", color: "#d7f5eb", fontSize: 13, border: "1px solid #365766" }}>
        {pending ? "กำลังตรวจสอบข้อมูลครับ…" : label}
      </Box>
      <ButtonBase className="neo-pet-button" onClick={onClick} disableRipple aria-label="เปิดแชตNeo" aria-controls="neo-chat-panel" aria-expanded={open}
        sx={{ width: { xs: 84, md: 104 }, height: { xs: 100, md: 120 }, borderRadius: 3, overflow: "visible", background: "transparent", "&:focus-visible": { outline: "2px solid #70efd2", outlineOffset: 3 }, "& .neo-avatar": { width: "100% !important", height: "auto !important", aspectRatio: "1" } }}>
        <NeoAvatar size={104} state={pending ? "think" : "idle"} />
        <span className="neo-pet-shadow" />
      </ButtonBase>
    </Box>
  );
}
